import React from "react";
import CmsManager from "./CmsManager";

function PhilosophyEditor() {
  return (
    <CmsManager
      title="Our Philosophy"
      resource="philosophy"
      singleton
      fields={[
        {
          name: "content",
          label: "Description",
          type: "richtext",
        },
        {
          name: "coreValues",
          label: "Core Values",
          type: "coreValues",
        },
        {
          name: "slug",
          label: "URL Slug",
          fullWidth: false,
          defaultValue: "our-philosophy",
        },
        { name: "metaTitle", label: "Title Tag", fullWidth: false },
        {
          name: "metaDescription",
          label: "Meta Description",
          type: "textarea",
          rows: 3,
        },
        {
          name: "metaKeywords",
          label: "Meta Keywords",
          type: "keywords",
          rows: 2,
        },
      ]}
    />
  );
}

export default PhilosophyEditor;
